import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkle } from "@phosphor-icons/react";
import { conciergeApi } from "@/lib/apiClient";
import { useTranslation } from "react-i18next";
import { PASSPORT_DESTINATION_PLACEHOLDER } from "@/constants/destinationImage";

export default function Trips({ onOpenPlanner }) {
    const { t } = useTranslation();
    const [conciergeTrips, setConciergeTrips] = useState([]);

    const load = () => {
        conciergeApi.listTrips().then(setConciergeTrips).catch(() => {});
    };
    useEffect(() => { load(); }, []);

    return (
        <div data-testid="trips-panel">
            <div className="flex items-center justify-between mb-6">
                <div>
                    <div className="overline mb-1">{t("trips.overline")}</div>
                    <div className="font-serif text-3xl text-white leading-none">{t("trips.title")}</div>
                </div>
                <Link to="/concierge" className="btn-gold text-sm !py-2.5 !px-5" data-testid="trips-plan">
                    <Sparkle size={14} weight="fill" /> {t("trips.openConcierge")}
                </Link>
            </div>

            {conciergeTrips.length > 0 && (
                <div className="mb-8">
                    <div className="text-[10px] tracking-[0.3em] uppercase mb-3" style={{ color: "var(--gold)" }}>{t("trips.conciergeTrips")}</div>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                        {conciergeTrips.map((tItem) => (
                            <Link
                                key={tItem.id}
                                to={`/trip/${tItem.id}`}
                                className="group rounded-2xl overflow-hidden relative transition-transform hover:-translate-y-1"
                                style={{ background: "var(--navy-deep)", border: "1px solid rgba(255,255,255,0.06)" }}
                                data-testid={`concierge-trip-${tItem.id}`}
                            >
                                <div className="aspect-[16/10] bg-cover bg-center" style={{ backgroundImage: `url(${tItem.hero_image || PASSPORT_DESTINATION_PLACEHOLDER})` }} />
                                <div className="absolute inset-0 pointer-events-none" style={{ background: "linear-gradient(180deg, rgba(11,19,32,0) 40%, rgba(5,10,17,0.9) 100%)" }} />
                                <div className="absolute bottom-0 left-0 right-0 p-4">
                                    <div className="text-[10px] tracking-[0.3em] uppercase text-white/70">{tItem.status?.replace("_", " ") || t("trips.planning")} · {tItem.days ? t("trips.days", { count: tItem.days }) : "?"}</div>
                                    <div className="font-serif text-lg text-white leading-tight mt-1 line-clamp-1">{tItem.emoji} {tItem.title}</div>
                                    <div className="text-white/70 text-[11px] mt-1 line-clamp-1">
                                        {(tItem.destinations || []).slice(0, 3).join(" · ")}
                                        {tItem.totals?.total_spent ? ` · ~$${Math.round(tItem.totals.total_spent).toLocaleString()}` : ""}
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            )}
            {conciergeTrips.length === 0 && (
                <div className="col-span-full text-center py-16 rounded-2xl" style={{ background: "var(--navy-deep)", border: "1px dashed rgba(255,255,255,0.1)" }}>
                    <div className="text-white/60">{t("trips.emptyTitle")}</div>
                    <Link to="/concierge" className="mt-4 inline-block text-xs" style={{ color: "var(--gold)" }} data-testid="trips-empty-plan">
                        {t("trips.emptyPlanLink")}
                    </Link>
                </div>
            )}
        </div>
    );
}
